import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
import KonfhubLoad from "../../components/KonfhubLoad";

export default function Logout() {
  useEffect(() => {
    let cancelled = false;

    const signOutAndRedirect = async () => {
      try {
        await Auth.signOut({ global: true });
      } catch (err) {
        console.warn("Logout: signOut error", err);
      }
      if (!cancelled) {
        window.location.href = "/login";
      }
    };

    signOutAndRedirect();
    return () => {
      cancelled = true;
    };
  }, []);

  return <KonfhubLoad />;
}
